/**-----------------------------------------------------------------------------------------
* Copyright © 2021 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the project root for more information
*-------------------------------------------------------------------------------------------*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var shared_module_1 = require("../../shared.module");
var footer_component_1 = require("./footer.component");
var exportedModules = [
    footer_component_1.FooterComponent
];
var importedModules = [
    common_1.CommonModule,
    shared_module_1.SharedModule
];
/**
 * @hidden
 */
var FooterModule = /** @class */ (function () {
    function FooterModule() {
    }
    FooterModule.exports = function () {
        return [];
    };
    FooterModule = tslib_1.__decorate([
        core_1.NgModule({
            declarations: [exportedModules],
            exports: [exportedModules],
            imports: importedModules.slice()
        })
    ], FooterModule);
    return FooterModule;
}());
exports.FooterModule = FooterModule;
